
import React, { useEffect, useState } from "react";
import MapSVG from "./MapSVG";
import { useSelector } from "react-redux";
import { GrFormClose, GrLocation, GrPhone, GrPhoneHorizontal } from "react-icons/gr";
import { motion } from "framer-motion";
import { fadeIn, slideIn, staggerContainer, } from "./utils/motion";
import Carousel from "react-multi-carousel";


export const MapSection = () => {



  const lang = useSelector((state) => state.cart.lang);
  const theme = useSelector((state) => state.cart.theme);
  const region = useSelector((state) => state.cart.branches);

  const [branch_,setBranch] = useState(0)

  const [state,setState] = useState(0)

  const [width, setWidth] = useState(window.innerWidth);
  
  useEffect(() => {
    const handleResize = () => setWidth(window.innerWidth);
    window.addEventListener("resize", handleResize);
  //  console.log(window.innerWidth);
    return () => window.removeEventListener("resize", handleResize);
    
  
  }, []);

  const [show,setShow] = useState(0)

  const Branch = ({branch,setBranch,setShow}) => {

  

    return (

      <div style={{cursor:'pointer'}} onClick={()=>{
        setBranch(branch.id)
 
if(show !== branch.id && show > 0){
  setShow(0)
}
      }} className="snap-end  snap-always ">
 <div  style={{fontFamily:'',placeContent:'center'}}  className={`w-full flex flex-col item-center  ${width >= 800 ? 'h-[80px]':'h-[80px]' } ${Number(branch_) === Number(branch.id) ? ` ${theme === 'LM' ? 'bg-primary text-white' : 'bg-primary_ text-black' }`:` ${theme === 'LM' ? 'bg-zinc-100 ' : 'bg-zinc-800' }`}  mb-1 `}>
 <div style={{placeContent:'center'}}  className={`w-full flex gap-1  `}>
  <p style={{placeContent:'center'}} className={`w-[70%] ${width >= 800 ? 'text-[15px]  ' : 'text-[12px]'} h-[40px]  ${lang === 'en' ? 'text-left' :'text-right'}  px-2 `}>  {lang=== 'en' ? branch.value_en : branch.value }</p>
  <div  className={`w-[30%]  m-auto flex  ${width >= 800 ? ' gap-3':'  gap-1' }`}> 
  <a target="_blank" href={`${branch.location}`} style={{justifyContent:'center'}} className=" " > <GrLocation  color={theme === 'LM' ? 'black' : 'white' } className={`${width >= 800 ? 'h-[25px] w-[25px]':'h-[19px] w-[19px]' }  ${theme === 'LM' ? 'bg-primary_' : 'bg-primary ' } rounded p-[2px] cursor-pointer `}/>  </a>
  <div style={{justifyContent:'center'}} className={``} >  {Number(show) === Number(branch.id) ? <GrFormClose color={theme === 'LM' ? 'black' : 'white' } onClick={()=>{setShow(0)}} className={`${width >= 800 ? 'h-[25px] w-[25px]':'h-[19px] w-[19px]' }   ${theme === 'LM' ? 'bg-primary_' : 'bg-primary ' } rounded p-[2px] cursor-pointer `}  /> : <GrPhone color={theme === 'LM' ? 'black' : 'white' } onClick={()=>{setShow(branch.id)}} className={`${width >= 800 ? 'h-[25px] w-[25px]':'h-[19px] w-[19px]' }   ${theme === 'LM' ? 'bg-primary_' : 'bg-primary ' } rounded p-[2px] cursor-pointer `}  />} </div>
  </div>
 </div>
 
{show === branch.id?
 <div  dir={lang === 'en' ? 'ltr' :'rtl'}  style={{fontFamily:'',overflowX:'auto',overflowY:'hidden'}}  className={`min-w-full h-[40px]  flex  ${width >= 800 ? 'gap-2':'gap-1' } item-center   px-[2px] `}>
 {branch.phones&&branch.phones.map((item, indx) => (
        <>
      
        <a style={{ background:theme === 'LM' ? '#FF9800' : '#2196f3' , color:theme === 'LM' ? 'black' : 'white'  ,height:'fit-content'}} className={` ${width >= 800 ? 'text-[12px] py-[2px]   ' : ' py-[1px]   text-[10px]'} px-1  mb-1 rounded flex`}  aria-label={`Mobile${indx}`} key={`phone-${indx}`} href={`tel:${item.phone}`} >
      <p className="m-auto">{item.phone}</p>  <GrPhone className="m-auto"   size={width >= 800 ? 13 : 10} />  
  </a>
 
        </> 
       

 
  
       

         ))}
 </div>
 
 :''}

  </div>


      </div>
    )

  }






  


  return (
 
      <motion.section
      variants={staggerContainer()}
     initial='hidden'
     whileInView='show'
     viewport={{ once:true, amount: 0.25 }} className=" mt-[8px] px-[3%]  w-full">
    <span className='hash-span' id={'Branches'}>
   
    </span>

    <motion.div variants={slideIn('right', '', 0.1, 1)} >
      <div className={`flex ${width >= 800 ? 'flex-row' : 'flex-col' }  gap-5  pt-10`}  >
      <h2 onClick={()=>setState(0)} style={{fontFamily:'CairoExtraBold',placeContent:'center'}}  className={` ${theme === 'LM' ? 'bg-zinc-100 text-primary ' : 'bg-zinc-800 text-primary_' } self-start min-h-[80px] ${width >= 800 ? 'min-w-[40%]' : 'min-w-full' }   text-center text-[15px]  lg:text-[40px]  md:text-[30px]  sm:text-[20px]  xs:text-[15px] `}>
      { lang === 'en' ? 'Service Available' :'خدمتنا متاحة'}   
          </h2>
          <div style={{overflowX:'auto'}} className={`flex ${theme === 'LM' ? 'light-scrollbar' : 'dark-scrollbar' } ${width >= 800 ? 'min-w-[60%]' : 'min-w-full' } gap-2 `}>
          {region.map((region, i) => (
            <button
              key={`Branch${i}`}
              onClick={()=>{
            
                setState(region.id)
                
                setBranch(0)
                setShow(0)

                }}
              style={{placeContent:'center'}}
              className={`     grow shrink-0 min-h-[80px] p-1  
              ${Number(region.id)===  Number(state) ? ` ${theme === 'LM' ? 'bg-primary text-white ' : 'bg-primary_ text-black ' }   px-5   ` : ` ${theme === 'LM' ? 'bg-zinc-100 ' : 'bg-zinc-800' }`}
               `}
            >
             {lang=== 'en' ? region.value_en : region.value }

            </button>
          ))}
          </div>
      </div>
   
<div className={`flex ${ 'flex-col ' }  gap-5  pt-10`}  >

     
          <div  style={{overflowX:'auto'}} className={`relative ${theme === 'LM' ?  'bg-zinc-100 text-primary ' : 'bg-zinc-800 text-primary_'  }   min-w-[60%]`}>
          <p style={{placeContent:'center'}}  className={`absolute top-[-2] w-full   text-center text-[10px]  lg:text-[20px]  md:text-[15px]  sm:text-[12px]  xs:text-[10px]  `}>
         {
          state > 0 && 
          lang ==='en' ?
           ` Branches in ${region.length} governorates in the Republic of Yemen `
           :
          ` خدمتنا تتواجد في ${region.length} محافظات في الجمهورية اليمنية`
          
        
        }
          </p>
         <MapSVG width={'100%'} color={theme === 'LM' ? '#2196f3' : '#FF9800'} used={region}  state={Number(state)}  setState={setState}/>
         

          </div>
      </div>

      </motion.div> 

    </motion.section>
    
  );
};
